import { GUID } from "../Services/ServiceTypes";

const LAST_OPEN_ITEM_NODE_KEY = 'lastOpenItemNode';

export const lastOpenItemNodeStore = {
  get(): GUID | null {    
    const xxx = localStorage.getItem(LAST_OPEN_ITEM_NODE_KEY);
    return xxx
  },
  set(lastOpenItemNodeId: GUID): void {
    localStorage.setItem(LAST_OPEN_ITEM_NODE_KEY, lastOpenItemNodeId);
  },
  clear(): void {
    localStorage.removeItem(LAST_OPEN_ITEM_NODE_KEY);
  },
};